module.exports = __webpack_public_path__ + "fonts/cadd869741b7c2e3a7c1cdb39ac60cee.txt";